import { render, staticRenderFns } from "./ListDraws.vue?vue&type=template&id=619d2279&scoped=true&"
import script from "./ListDraws.vue?vue&type=script&lang=js&"
export * from "./ListDraws.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/draws.scss?vue&type=style&index=0&id=619d2279&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d2279",
  null
  
)

export default component.exports